import axios from 'axios';
import store from '../store/store';
import { SecurityReducer } from '../redux/security';
import { generateRSAKeys, decryptApiData } from '../config/security';
import APIRoutes from './APIRoutes.json';

const SecurityActions = SecurityReducer.actions;

// Performs the /startup handshake: generate a local RSA keypair, send our public
// key, and recover the server's public key from the (encrypted) response. The
// startup route is exempt from the transport encryption in Axios.js, so the
// response interceptor hands the raw body back here to decrypt with our own
// private key. Mirrors midani-frontend's handShakeFunc.
export const handShakeFunc = async () => {
  const { publicKey, privateKey } = await generateRSAKeys();

  const startup = APIRoutes.STARTUP_API;
  const handshakeResult = await axios[startup.method](startup.url, { publicKey }, {
    headers: { token_type: startup.token_type },
  });

  const decryptResult =
    handshakeResult.handler
      ? await decryptApiData(privateKey, handshakeResult)
      : { serverPublicKey: handshakeResult.data?.serverPublicKey ?? handshakeResult.serverPublicKey };

  return {
    ...decryptResult,
    localPublicKey: publicKey,
    localPrivateKey: privateKey,
  };
};

// Runs the handshake and stores the resulting keys in the security slice.
export const performHandshake = async () => {
  const handshakeResult = await handShakeFunc();
  store.dispatch(
    SecurityActions.updateSecurity({
      serverPublicKey: handshakeResult.serverPublicKey,
      localPublicKey: handshakeResult.localPublicKey,
      localPrivateKey: handshakeResult.localPrivateKey,
    }),
  );
  return handshakeResult;
};
